// extracted by mini-css-extract-plugin
export default {"container":"ProductDetailsSection__container___fjoxd"};